import { z } from 'zod';

const allVars = {
  envUrl: import.meta.env.VITE_APP_BACK_OFFICE_URL,
  sentryEnvironment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
};

const AllVarsSchema = z.object({
  envUrl: z.string(),
  sentryEnvironment: z.string(),
});

export const environment = AllVarsSchema.parse(allVars);
